import {Injectable} from '@angular/core';
import {Backend, SingleResponse} from "@generated-backend-types";
import {Observable} from "rxjs";
import {HttpEvent} from "@angular/common/http";
import {BaseEndpointService} from '../../../../services/api/base-endpoint-service';
import {ListItem} from '../../../../entities/list-item.entity';
import PrivateAttachmentData = Backend.App.Data.Attachments.PrivateAttachmentData;
import PrivateAttachment = Backend.App.Resources.Dashboard.Administration.PrivateAttachment;

@Injectable({providedIn: 'root'})
export class PrivateAttachmentsApiService extends BaseEndpointService<PrivateAttachment, Partial<PrivateAttachmentData>> {

  protected override endpoint = '/administration/private-attachments'


  public upload(data: PrivateAttachmentData): Observable<HttpEvent<SingleResponse<PrivateAttachment>>> {
    const formData = this.setFormData(data);
    return this.http.post<SingleResponse<PrivateAttachment>>(this.endpoint, formData, {
      reportProgress: true,
      observe: 'events'
    })
  }

  public directUpload(data: PrivateAttachmentData): Observable<SingleResponse<PrivateAttachment>> {
    const formData = this.setFormData(data);
    return this.http.post<SingleResponse<PrivateAttachment>>(this.endpoint, formData)
  }

  private setFormData(data: PrivateAttachmentData): FormData {
    const formData = new FormData();
    formData.set('file', data.file);
    formData.set('name', data.name ?? '');
    formData.set('attachable_type', data.attachable_type);
    formData.set('attachable_id', data.attachable_id ?? '');
    formData.set('type', data.type ?? '');

    return formData;
  }

  public override modelToMultiSelectItem(m: PrivateAttachment): ListItem & { model: PrivateAttachment } {
    return {
      id: m.id,
      text: m.name,
      isDisabled: false,
      model: m,
    }
  }
}
